// fetchUtils.js
import apiClient from "../api/axiosInstance"; // Your axios instance

export const fetchApplications = async () => {
  try {
    const response = await apiClient.get("/api/all-applications");
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error; 
  }
};